
export default {
  created () {
    this.columns = [
      {
        field: 'created_at',
        title: '下载时间',
        width: 200,
        sortable: true,
        formatter: ({ cellValue }) => {
          return cellValue ? this.$moment(cellValue).format('YYYY-MM-DD') : '-'
        },
      },
      {
        field: 'ip',
        title: '下载IP',
      },
      {
        field: 'version',
        title: '软件版本',
      },
      {
        field: 'iso_name',
        title: '镜像名称',
      },
    ]
  },
}
